import React from "react";
import styled from "@yb/styled-px2rem";

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

interface RadioProps extends InputProps {
	id?: string;
	chlidren?: React.ReactNode;
	$position?: "left" | "right";
	disabled?: boolean;
	checked?: boolean;
}

const RadioWrap = styled.div<{$position?: "left" | "right"}>`
	display: flex;
	flex-direction: ${props => (props.$position === "left" ? "row" : "row-reverse")};
	align-items: start;
	gap: 10px;
	line-height: 1;

	input[type="radio"] {
		position: relative;
		width: 24px;
		min-width: 24px;
		height: 24px;
		min-height: 24px;
		border-radius: 100%;
		border-color: var(--border-color);
		cursor: pointer;

		&::before {
			position: absolute;
			top: 50%;
			left: 50%;
			width: 0;
			height: 0;
			border-radius: 50%;
			transform: translate(-50%, -50%);
			content: "";
			cursor: pointer;
			transition: all 250ms ease;
			box-sizing: border-box;
		}

		&:focus {
			border: 1px solid var(--brand-color);
			outline: none;
		}

		&:checked {
			border: 1px solid var(--brand-color);
			&::before {
				width: 12px;
				height: 12px;
				background-color: var(--brand-color);
			}
		}

		&:disabled {
			background-color: var(--disable-bg-color);
			border: 1px solid var(--border-color);
			cursor: initial;
			&:before {
				background-color: var(--gray-color);
				cursor: initial;
			}
			+ label {
				color: var(--disable-text-color);
				cursor: initial;
				> span {
					color: var(--disable-text-color);
				}
			}

			&:checked {
				border: 1px solid var(--border-color);
				&::before {
					background-color: var(--disable-text-color);
				}
			}
		}
	}

	label {
		line-height: 1.5;
		font-size: 16px;
		font-family: "PT-semibold";
		color: var(--title-color);
		&:has(input[type="radio"]:disabled) {
			cursor: intial;
		}

		span {
			margin-left: 4px;
			font-size: 16px;
			font-family: "PT-medium";
			color: var(--caption-color);
		}
	}
`;

const RadioN = ({id, children, $position = "left", disabled, checked, ...props}: RadioProps) => (
	<RadioWrap $position={$position}>
		<input type="radio" id={id} disabled={disabled} checked={checked} {...props} />
		{children ? <label htmlFor={id}>{children}</label> : <></>}
	</RadioWrap>
);

export default RadioN;
export {RadioWrap};
